import React, { useEffect, useState } from 'react'
import Paper from '@modul-connect/shared/components/atoms/paper'
import Page from '@modul-connect/shared/components/atoms/page.v2'
import { connect, useDispatch, useSelector } from 'react-redux'
import SearchWidget from '@modul-connect/shared/components/molecules/searchWidget.v2'
import TableWidget from '@modul-connect/shared/components/molecules/tableWidget'
import { allTeams_columns } from './team_columns'
import KpiRow from '@modul-connect/shared/components/molecules/kpiRow/kpiRow'
import { getAllUsersFromOrganisation } from '../../../state/actions/customer'
import { useAuth0 } from '@auth0/auth0-react'

export const FleetUsers = ({ orgId }) => {

  const [users, setUsers] = useState('')
  const [tableOptions, setTableOptions] = useState(null)
  const [kpiData, setKpiData] = useState([])
  
  const { getAccessTokenSilently } = useAuth0()
  const dispatch = useDispatch()


  const allUsers = useSelector(state => state.all_users)
  const subtrees = useSelector(state => state.subtrees.subtrees)
  const loading = useSelector(state => state.loading)
  const isLoading = loading.allUsers === 'loading'


  const organisationName = subtrees.find(s => s.uuid === orgId)?.name
  
  useEffect(() => {  
    const usersWithTeam = allUsers.users.filter(user => {
      const teams = user.teams
      return !teams.includes(organisationName)
    })
  
    setKpiData([
      { title: 'Total Users', value: allUsers.total },
      { title: 'In teams', value: usersWithTeam.length },
    ])
  }, [orgId, allUsers])

  useEffect(() =>  {
    getAccessTokenSilently().then(token => {
      dispatch(getAllUsersFromOrganisation(token, orgId))
    })
  }, [orgId])
  
  
  const formattedData = allUsers.users.map((user) => ({
    id: user.email,
    name: `${user.firstName} ${user.lastName}`,
    privilege: user.role,
    email: user.email,
    date: user.registered.split('T')[0],
    team: user.teams.join(', ').replace(organisationName, '-')
    
  }))

  let filterTimer = null

  const handleNameChange = (event) => {
    setFilterAfterDelay(event.target.value)
  }

  const setFilterAfterDelay = (newFilter) => {
    if (filterTimer) {
      clearTimeout(filterTimer)
    }

    filterTimer = setTimeout(() => {
      setUsers(newFilter)
    }, 1000)
  }

  const sortByColumn = (data, column) => {
    if (!Array.isArray(data)) return data
      
    const isDesc = column.endsWith('desc')
    const key = isDesc ? column.replace(/desc$/i, '') : column
  
    return [...data].sort((a, b) => {
      const v1 = a[key] || ''
      const v2 = b[key] || ''
      return isDesc
        ? v2.localeCompare(v1, undefined, { numeric: true })
        : v1.localeCompare(v2, undefined, { numeric: true })
    })
  }

  const filteredData = formattedData.filter((user) =>
    user.name.toLowerCase().includes(users.toLowerCase()) ||
    user.email.toLowerCase().includes(users.toLowerCase()) ||
    user.team.toLowerCase().includes(users.toLowerCase())
  )

  const sortKey = tableOptions?.sort || 'name'
  const sortedUsers = sortByColumn(filteredData, sortKey)

  const usersToDisplay = !tableOptions ? sortedUsers : sortedUsers.
    slice(tableOptions.rowsPerPage * (tableOptions.currentpage -1), filteredData.length)

  return (
    <Page>
      <KpiRow width={'100%'} bgColor={'white'} data={kpiData} isLoading={isLoading}/> 
      <Paper title={'Users'}>
        <SearchWidget
          onChange={handleNameChange}
          placeholder={'Search for user...'}
          initialValue={users}
        />
        <TableWidget
          data={usersToDisplay}
          columns={allTeams_columns}
          totalItems={filteredData?.length}
          defaultSort="name"
          searchStr={users}
          disableClickCondition={() => true}
          themes={{ device: 'desktop' }} 
          loadingStatus={loading?.allUsers}
          extend={{ width: '100%', paddingTop: 24 }}
          onFetchData={(options) => {
            setTableOptions((options))
          }}
        />
      </Paper>
    </Page>
  )
  
}

const mapStateToProps = props => props

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(FleetUsers)